import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class PaymentInfoFeeApi extends NewviewOaBaseApi { 
    
    public get ControllerName(): any {
        return 'payment-info-fee'
    }
}